import HelpTip from '../../../components/HelpTip';

interface StatePromptPrefixSectionProps {
  title: string;
  description: string;
  value: string;
  rows: number;
  ratio: string;
  placeholder?: string;
  actionLabel?: string;
  helpText?: string;
  outputRatioLabel: string;
  onChange: (value: string) => void;
  onRatioChange: (ratio: string) => void;
  onAction?: () => void;
}

export default function StatePromptPrefixSection({
  title,
  description,
  value,
  rows,
  ratio,
  placeholder,
  actionLabel,
  helpText,
  outputRatioLabel,
  onChange,
  onRatioChange,
  onAction,
}: StatePromptPrefixSectionProps) {
  return (
    <div style={{ borderTop: '1px solid var(--border)', paddingTop: '0.75rem' }}>
      <p style={{ margin: '0 0 0.5rem', fontSize: '0.82rem', fontWeight: 600, color: 'var(--text-2)' }}>
        {title}
        {helpText && <HelpTip text={helpText} />}
      </p>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
        <span style={{ fontSize: '0.78rem', color: 'var(--text-2)' }}>{description}</span>
        {actionLabel && onAction && (
          <button
            type="button"
            onClick={onAction}
            style={{ fontSize: '0.72rem', color: 'var(--primary)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginLeft: 'auto', whiteSpace: 'nowrap' }}
          >
            {actionLabel}
          </button>
        )}
      </div>
      <textarea
        value={value}
        onChange={event => onChange(event.target.value)}
        rows={rows}
        style={{ width: '100%', fontSize: '0.82rem', border: '1px solid var(--border)', borderRadius: '4px', padding: '4px 8px', resize: 'vertical', boxSizing: 'border-box' }}
        placeholder={placeholder}
      />
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '6px', fontSize: '0.78rem' }}>
        <span style={{ color: 'var(--text-2)' }}>{outputRatioLabel}</span>
        {['16:9', '9:16', '1:1', '4:3', '3:4'].map(option => (
          <button
            key={option}
            type="button"
            onClick={() => onRatioChange(option)}
            style={{
              fontSize: '0.72rem',
              padding: '2px 10px',
              borderRadius: '4px',
              border: '1px solid ' + (ratio === option ? 'var(--primary)' : 'var(--border)'),
              background: ratio === option ? 'var(--primary)' : 'transparent',
              color: ratio === option ? '#fff' : 'var(--text-2)',
              cursor: 'pointer',
            }}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}
